<template>
  <div>
    <h5 v-if="existContent" class="title mt-4 mb-4">
      Conteúdos complementares
    </h5>
    <a
      v-for="(file, index) in lesson.extra_files"
      :key="'f' + index"
      class="w-100 material d-flex mb-3"
      :href="file.file"
      target="_blank"
    >
      <i :class="`mr-2 ${getIcon(file)}`"></i>
      <span class="flex-fill">{{ file.name }}</span>
      <i class="fa fa-arrow-up-right-from-square"></i>
    </a>

    <a
      v-for="(reading, index) in lesson.extra_reading"
      :key="'r' + index"
      :href="reading.link"
      target="_blank"
      class="w-100 material d-flex mb-3"
    >
      <i class="mr-3 fa fa-link ml-n2"></i>
      <span class="flex-fill">
        <strong>{{ reading.site_name }}</strong>
        : {{ reading.title }}
      </span>
      <i class="fa fa-arrow-up-right-from-square"></i>
    </a>
  </div>
</template>
<script>
import get from "lodash/get";
export default {
  props: ["lesson"],
  computed: {
    existContent() {
      return (
        (this.lesson.extra_files && this.lesson.extra_files.length > 0) ||
        (this.lesson.extra_reading && this.lesson.extra_reading.length > 0)
      );
    }
  },
  methods: {
    getIcon(file) {
      const extension = get(file, "file", ".*")
        .split(".")
        .pop();
      const MAP = {
        pdf: "icon-book ml-n2",
        txt: "icon-book ml-n2",
        doc: "icon-book ml-n2",
        mp3: "icon-song",
        ogg: "icon-song",
        mp4: "icon-play",
        mov: "icon-play",
        flv: "icon-play",
        png: "icon-image mr-3",
        jpg: "icon-image mr-3",
        webp: "icon-image mr-3",
        "*": "icon-link"
      };
      return MAP[extension];
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  line-height: 34px;
}
.title {
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.material {
  border-radius: 8px;
  padding: 19px 20px;
  text-align: left;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  text-decoration: none;
  border: 1px solid transparent;

  .fa.fa-link,
  .fa.fa-arrow-up-right-from-square {
    font-size: 16px !important;
  }

  i {
    font-size: 24px !important;
  }

  &:hover {
    border: 1px solid var(--verso-light-roxo, #3e56ac);
  }
}
</style>
